export const DictionaryMenu = [
  {
    id: "dictionariesLanguages",
    label: "Języki",
  },
  {
    id: "dictionariesAttributes",
    label: "Atrybuty",
  },
  {
    id: "dictionariesFileTypes",
    label: "Typy plików",
  },
  {
    id: "dictionariesCertificates",
    label: "Certyfikaty",
  },
  {
    id: "dictionariesProductLines",
    label: "Linie produktów",
  },
  {
    id: "dictionariesMaterials",
    label: "Materiały",
  },
  {
    id: "dictionariesAwards",
    label: "Nagrody",
  },
  {
    id: "dictionariesPackagings",
    label: "Opakowania",
  },
  {
    id: "dictionariesCategories",
    label: "Kategorie",
  },
  {
    id: "dictionariesSpimCategories",
    label: "Kategorie SPIM",
  },
  {
    id: "dictionariesWarranties",
    label: "Gwarancje",
  },
  {
    id: "dictionariesBrands",
    label: "Marki",
  },
  {
    id: "dictionariesDestiny",
    label: "Przeznaczenie",
  },
  {
    id: "dictionariesOrginCountries",
    label: "Kraje pochodzenia",
  },
];
